require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-beginner-level-students-level-up-with-web-app-drum-kit.json") })
        }
      }, "path---blog-beginner-level-students-level-up-with-web-app-drum-kit");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-beginner-level-students-level-up-with-web-app-drum-kit!./.cache/json/blog-beginner-level-students-level-up-with-web-app-drum-kit.json
// module id = 721
// module chunks = 231608221292675